import { ROUTES } from './routes';

/**
 * 푸시 알림 코드 → 앱 라우트 매핑.
 *
 * native 가 알림 탭 시 `RemoteMessage.data` 원본을 web 으로 전달하고(라우팅 SSOT=web),
 * web 이 본 맵으로 목적지를 결정한다. 코드 체계는 참조 앱(heviton-app-frontend)의
 * `M_HEVITON_*` 를 승계 — **BE 가 실제로 보내는 코드·목적지는 미확정이라 확인 필요**
 * (skill-api-issues). 미확정 코드는 fallback(HOME)로 흡수.
 *
 *   PI = 발전량(대시보드) / PS = 발전통계 / PE = 이상알림 / PR = 수익분석(참조 "reports" 근사)
 */
export const PUSH_CODE_TO_ROUTE: Record<string, string> = {
  M_HEVITON_PI: ROUTES.DASHBOARD,
  M_HEVITON_PS: ROUTES.STATS_GENERATION,
  M_HEVITON_PE: ROUTES.ALERTS,
  M_HEVITON_PR: ROUTES.REVENUE,
};

/**
 * 푸시 `data` 페이로드에서 이동할 앱 내부 경로를 해석.
 *   1) `data.url` — 딥링크(내부 경로 또는 `<scheme>://<path>`). 경로만 추출해 우선 채택.
 *   2) `data.code` — 코드 매핑(PUSH_CODE_TO_ROUTE).
 * 해석 불가 시 null (호출처가 fallback 결정).
 */
export function resolvePushRoute(data: Record<string, string>): string | null {
  const url = data.url;
  if (url) {
    // `heviton-user-app://stats/generation` · `/stats/generation` 모두 경로만 남긴다.
    const path = url.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '');
    const normalized = path.startsWith('/') ? path : `/${path}`;
    if (normalized.length > 1) return normalized;
  }
  const code = data.code;
  return (code && PUSH_CODE_TO_ROUTE[code]) ?? null;
}
